<div class="dropdown add-to" (clickOutside)="closeDropdown()">
  <button data-testid="auto-app-add-to-pipeline-stage-button-1" class="btn-trms-light dropdown-toggle w-100" type="button" (click)="toggleDropdown()">
   {{statusname?.value ? statusname?.value : 'Select a Stage'}}
  </button>

  @if(isDropdownOpen) {
  <div class="custom-dropdown-menu w-100">

    <!-- Search -->
    <div class="custom-dropdown-search">
      <i class="fa fa-search search-icon"></i>
      <input data-testid="auto-app-add-to-pipeline-stage-input-1" type="text" placeholder="Search for..." [formControl]="stageSearch" (input)="filterStage()"
        class="search-input">
    </div>

    <!-- List -->
    <ul class="custom-dropdown-list">
      @for(stage of filteredStageList; track stage) {
      <li class="custom-dropdown-item" [class.active]="selectdStage === stage" (click)="createStage(stage)">
        {{ stage | titlecase }}
      </li>
      }
      @if(filteredStageList.length === 0) {
      <li class="custom-dropdown-item no-results">No results found</li>
      }
    </ul>

    <!-- Create New -->
    <div class="custom-dropdown-footer" (click)="createNewStage()">
      <i class="fa fa-plus mr-2"></i>
      <span>Create New Stage</span>
    </div>

  </div>
  }
</div>

<ng-template #createStageModal>
    <div class="modal-header hire-modal-header w-100">
      <div class="d-flex justify-content-between text-defualt w-100">
          <span class="font-weight-600">Create New Status</span>
          <span class="f-14 font-weight-600 pointer"  (click)="dismiss()">
            <span>
            <i class="fa-solid fa-times" aria-hidden="true"></i>
          </span>
        </span>
      </div>
    </div>
    <div class="modal-body">
        <div>

          <p class="f-12 font-weight-500 text-black mb-4">Create a custom status to better track your hiring process</p>
        </div>

    <div class="row">
      <div class="mb-3">
    <p class="f-12 font-weight-500 mb-1">Status Name
    </p>
      <input data-testid="auto-app-add-to-pipeline-stage-input-2" type="text" class="wc-form-control" placeholder="Eg. Awaiting feedback" [formControl]="statusname">
      @if(statusname.hasError('noHtml')) {
      <p class="f-12 text-danger mb-0 mt-1">Status name cannot contain &lt; or &gt; characters</p>
      }
          </div>
    </div>

    <div class="d-flex text-right justify-content-end">
      <button data-testid="auto-app-add-to-pipeline-stage-button-2" class="btn-trms-gray" (click)="dismiss()">
        Cancel
      </button>
      <button data-testid="auto-app-add-to-pipeline-stage-button-3" class="btn-trms-small ml-1" [disabled]="statusname.invalid" (click)="createStage()">Create</button>
    </div>
   </div>
</ng-template>
@if(successMessage) {
<ngb-alert class="ngb-alert" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>
}

@if(errorMessage) {
<ngb-alert class="ngb-alert error-message-alert"  type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
}
